// extracted by mini-css-extract-plugin
export default {"mainbuttonpage":"GoBackButton_mainbuttonpage__i5tcS"};